import React, { useState, useContext } from 'react';
import { makeStyles } from '@mui/styles';
import { Box, CircularProgress } from '@mui/material';
import { AccountLink, SubTitle, Title } from '../common';
import KenInput from '../../../Components/KenInput';
import KenButton from '../../../Components/KenButton';
import { useNavigate } from 'react-router-dom';
import routes from '../../../Constants/routes';
import LoginBG from '../../../Assets/Svg/login-bg.svg';
import MobileLoginBG from '../../../Assets/Svg/login-mobile-bg.svg';
import { useForm, Controller } from 'react-hook-form';
import { requestForOTP } from '../api';
import { useSnackbar } from 'notistack';
import { handleError } from '../util';
import AuthLayout from '../AuthLayout';
import { REGEX } from '../../../Constants/constant';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    backgroundImage: `url(${LoginBG})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    [theme.breakpoints.down('sm')]: {
      backgroundImage: `url(${MobileLoginBG})`,
      marginRight: "150px !important",
    },
    [`@media (min-width: 350px) and (max-width: 400px)`]: {
      marginRight: "120px !important",
    },
    [`@media (min-width: 400px) and (max-width: 450px)`]: {
      marginRight: "120px !important",
    },
    [`@media (min-width: 450px) and (max-width: 500px)`]: {
      marginRight: "140px !important",
    },
    [`@media (min-width: 500px) and (max-width: 550px)`]: {
      marginRight: "170px !important",
    },
    [`@media (min-width: 550px) and (max-width: 600px)`]: {
      marginRight: "190px !important",
    },

    // '& form': {
    //   top: () => (1 / window.devicePixelRatio === 1 ? '50%' : 0),
    //   transform: () =>
    //     1 / window.devicePixelRatio === 1 ? 'translateY(-50%)' : 0,
    //   position: () => (1 / window.devicePixelRatio === 1 ? 'relative' : 0),
    // },
  },
  loginContent: {
    minWidth: '500px',
    minHeight: '520px',
    // 'box-shadow': '0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)',
    'border-radius': '16px',
    padding: '48px 84px',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      boxShadow: 'none',
      padding: '8px',
      minWidth: '360px',
    },
  },
  title: {
    marginBottom: '16px',
  },
  subTitle: {
    marginBottom: '32px',
  },
  inputFieldLabel: {
    'font-style': 'normal',
    'font-weight': '400',
    'font-size': '14px',
    'line-height': '100%',
    'text-transform': 'capitalize',
    color: '#505F79',
  },
  verify: {
    width: '100%',
    height: '48px',
    marginBottom: '40px',
    fontSize: '16px !important',
    fontWeight: '600 !important',
    color: '#092682 !important',
    background: '#f6c445 !important',
    fontFamily: 'Poppins,sans-serif',
  },
  signupWith: {
    'font-style': 'normal',
    'font-weight': '400',
    'font-size': '14px',
    'line-height': '100%',
    color: theme.palette.KenColors.neutral100,
  },
  signupWithItem: {
    margin: '0 8px',
    width: '40px',
    height: '40px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 0px 1px rgba(0, 0, 0, 0.04)',
    '& img': {
      height: '24px',
      width: '24px',
    },
    '& img.google': {
      width: '37px',
      height: '40px',
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
}));

export default function Login() {
  const classes = useStyles();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const res = await requestForOTP(data);

      if (!res || !res?.success) {
        return enqueueSnackbar(res?.errorMessage || 'Something went wrong', {
          variant: 'error',
        });
      }
      // if (res?.success) {
      //   alert(`OTP is: ${res?.OTP}`);
      // }

      navigate(routes.loginOTP, {
        state: {
          id: res.applicantId,
          currentId: data.id,
        },
      });
    } catch (error) {
      handleError(enqueueSnackbar, error);
      setTimeout(() => navigate(routes.signup), 3000);
    } finally {
      setLoading(false);
    }
  };

  const { control, handleSubmit } = useForm({
    defaultValues: {
      id: '',
    },
    mode: "onChange"
  });

  return (
    <AuthLayout>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box className={classes.loginContent} display={'flex'} flexDirection="column" justifyContent={'flex-start'} alignItems="flex-start" position={"relative"}>
          <img src={'https://inazstgpfs3001.blob.core.windows.net/assets/VVI/VVI%20-%20logo.png'} alt="Ken42 Icon" style={{ width: '300px', margin: "30px auto" }} />
          <Title className={classes.title} text="Login" />
          <SubTitle className={classes.subTitle} text="Please enter your login credentials below to start." />
          <Box mb={4} width="100%">
            <Controller
              name="id"
              control={control}
              rules={{ required: "Please enter you email ID", pattern: {value: REGEX.EMAIL, message: "Please enter valid email ID"} }}
              render={({ field, fieldState: { error } }) => (
                <KenInput
                  name="id"
                  placeholder="Please enter your Email ID"
                  labelClassName={classes.inputFieldLabel}
                  error={error?.message || error?.type}
                  {...field}
                />
              )}
            />
          </Box>
          <KenButton variant="roundedButton" buttonClass={classes.verify} type="submit" disabled={loading}>
            Verify
          </KenButton>
          {loading && (
            <CircularProgress
              size={24}
              sx={{
                position: 'absolute',
                top: '50%',
                left: '49%',
                transform: 'translate(-50%, -50%)',
              }}
            />
          )}
          <Box display={'flex'} justifyContent="center" width="100%" marginBottom="40px">
            <AccountLink text="Don’t have an account?" actionText={'Sign up'} onAction={() => navigate(routes.signup)} />
          </Box>
        </Box>
      </form>
    </AuthLayout>
  );
}
